
import { defineComponent, onMounted, computed, ref, inject } from 'vue'
import sportService from "@/core/services/SportService"
import { errManager, showMessage } from "@/core/config/Tools";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

import AddEdit from "./AddEdit.vue"

export default defineComponent({
    name: "Sports",
    components: {
        AddEdit
    },
    setup() {
        const loader = ref(false)
        const searchType = ref('')
        const searchText = ref('')
        const setting = ref({
            types: []
        })
        const rowItem = ref({})
        const listSports = ref < any > ([])

        //Pagination start
        const pageSize = ref(10)
        const currentPage = ref(1)
        const totalItems = ref(0)

        //get sharing data
        const gblDialog = inject < any > ('gblDialog')
        const gblAction = inject < any > ('gblAction')

        const getSetting = async () => {
            await sportService.getSetting()
            .then( (res) => {
                setting.value = res.data
            }).catch( ({response}) => {
                errManager(response, null, 2)
            })
        }

        const getData = async () => {
            loader.value = true
            await sportService.getData({
                    search: searchText.value,
                    type: searchType.value,
                    pageSize: pageSize.value,
                    currentPage: currentPage.value
                })
                .then((res) => {
                    listSports.value.length = 0
                    listSports.value = res.data.list
                    totalItems.value = res.data.total
                    loader.value = false
                }).catch(({
                    response
                }) => {
                    listSports.value.length = 0
                    loader.value = false
                })
        }

        const onDelete = (row) => {
            Swal.fire({
                title: 'Eliminar deporte',
                html: `¿Desea eliminar el deporte <b>${row.business}</b> de forma permanente?`,
                icon: 'warning',
                showClass: {
                    popup: 'animate__animated animate__fadeInDown'
                },
                hideClass: {
                    popup: 'animate__animated animate__fadeOutUp'
                },
                showCancelButton: true,
                confirmButtonText: 'Eliminar',
                cancelButtonText: 'Mantener',
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return sportService.delete(row.idsport)
                    .then( (res) => {
                        return res.data
                    }).catch(({response}) => {
                        Swal.showValidationMessage(
                        `Request failed: ${response}`
                        )
                    })
                },
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        icon: result.value.status,
                        title: result.value.title,
                        html: result.value.message
                    })
                    result.value.status === 'success' && getData();
                }   
            })
        }

        const handleCurrentChange = (val: number) => {
            currentPage.value = val
            getData()
        }

        const onRegister = () => {
            gblAction.value = 'new';
            gblDialog.value = true
        }

        const onEdit = (row) => {
            rowItem.value = row
            gblAction.value = 'edit';
            gblDialog.value = true
        } 

        const onResponse = (data) => {
            gblDialog.value = false
            showMessage(data)
            if (data.status == 'success')
                getData()
        }

        onMounted(async () => {
            getSetting()
            getData()
        })

        return {
            loader,
            searchType,
            searchText,
            setting,
            listSports,
            //page
            pageSize,
            currentPage,
            totalItems,
            handleCurrentChange,
            rowItem,
            //events
            getSetting,
            getData,
            onRegister,
            onEdit,
            onDelete,
            onResponse

        }

    },
})
